// File: typescript/apps/front-end/src/main/react/group/invite/openGroupInviteLinkPanel.ts
//
// The one opener for the leader's invite link panel (chat completeness §F18, D24), shared by the group page's
// overflow and the room menu. The panel itself is code-split (rule 26): only a leader who presses the item
// pays for it.

import { importChunkWithRetryAndReload } from "@/lib/lazyWithRetry";
import type { GroupInviteLinkPanelArgs } from "@/main/react/group/invite/GroupInviteLinkPanel";

export function openGroupInviteLinkPanel(args: GroupInviteLinkPanelArgs): Promise<void> {
    return importChunkWithRetryAndReload(
        () => import("@/main/react/group/invite/GroupInviteLinkPanel"),
        "group-invite-link-panel",
    ).then((module) => module.default(args));
}
